<div class="topAlert">
    <div *ngFor="let item of logService.backendErrorMessages" class="alert alert-danger alert-dismissible" role="alert">
        <h6 class="alert-heading mb-1">
            <i class="bx bx-xs bx-bug me-2"></i>
            {{'Alert.Error' | translate}}
        </h6>
        <p *ngFor="let secondItem of item.messages">
            {{secondItem | translate}}
        </p>
        <button type="button" class="btn-close" data-bs-dismiss="alert" (click)="logService.deleteItemError(item.id)"
            aria-label="Close"></button>
    </div>
    <div *ngFor="let item of logService.errorMessages" class="alert alert-danger alert-dismissible" role="alert">
        <h6 class="alert-heading mb-1">
            <i class="bx bx-xs bx-bug me-2"></i>
            {{'Alert.Error' | translate}}
        </h6>
        <span>
            {{item.message | translate}}
        </span>
        <button type="button" class="btn-close" data-bs-dismiss="alert" (click)="logService.deleteItemError(item.id)"
            aria-label="Close"></button>
    </div>
    <div *ngFor="let item of logService.errorJsonMessages" class="alert alert-danger alert-dismissible" role="alert">
        <h6 class="alert-heading mb-1">
            <i class="bx bx-xs bx-bug me-2"></i>
            {{'Alert.Error' | translate}}
        </h6>
        <span>
            <pre>
                {{item.message | jsonData}}
            </pre>
        </span>
        <button type="button" class="btn-close" data-bs-dismiss="alert" (click)="logService.deleteItemError(item.id)"
            aria-label="Close"></button>
    </div>
    <div *ngFor="let item of logService.warningMessages" class="alert alert-warning alert-dismissible" role="alert">
        <h6 class="alert-heading mb-1">
            <i class="fa-solid fa-triangle-exclamation"></i>
            {{'Alert.Warning' | translate}}
        </h6>
        <span>
            {{item.message | translate}}
        </span>
        <button type="button" class="btn-close" data-bs-dismiss="alert" (click)="logService.deleteItemWarning(item.id)"
            aria-label="Close"></button>
    </div>
    <div *ngFor="let item of logService.backendWarningMessages" class="alert alert-warning alert-dismissible" role="alert">
        <h6 class="alert-heading mb-1">
            <i class="fa-solid fa-triangle-exclamation"></i>
            {{'Alert.Warning' | translate}}
        </h6>
        <span *ngFor="let secondItem of item.messages">
            {{secondItem | translate}}
        </span>
        <button type="button" class="btn-close" data-bs-dismiss="alert" (click)="logService.deleteItemWarning(item.id)"
            aria-label="Close"></button>
    </div>
    <div *ngFor="let item of logService.warningJsonMessages" class="alert alert-warning alert-dismissible"
        role="alert">
        <h6 class="alert-heading mb-1">
            <i class="fa-solid fa-triangle-exclamation"></i>
            {{'Alert.Warning' | translate}}
        </h6>
        <span>
            <pre>
                {{item.message | jsonData}}
            </pre>
        </span>
        <button type="button" class="btn-close" data-bs-dismiss="alert" (click)="logService.deleteItemWarning(item.id)"
            aria-label="Close"></button>
    </div>
    <div *ngFor="let item of logService.infoMessages" class="alert alert-primary alert-dismissible" role="alert">
        <h6 class="alert-heading mb-1">
            <i class="fa-solid fa-info"></i>
            {{'Alert.info' | translate}}
        </h6>
        <span>
            {{item.message | translate}}
        </span>
        <button type="button" class="btn-close" data-bs-dismiss="alert" (click)="logService.deleteItemInfo(item.id)"
            aria-label="Close"></button>
    </div>
    <div *ngFor="let item of logService.backendInfoMessages" class="alert alert-primary alert-dismissible" role="alert">
        <h6 class="alert-heading mb-1">
            <i class="fa-solid fa-info"></i>
            {{'Alert.info' | translate}}
        </h6>
        <span *ngFor="let secondItem of item.messages">
            {{secondItem | translate}}
        </span>
        <button type="button" class="btn-close" data-bs-dismiss="alert" (click)="logService.deleteItemInfo(item.id)"
            aria-label="Close"></button>
    </div>
    <div *ngFor="let item of logService.infoJsonMessages" class="alert alert-primary alert-dismissible" role="alert">
        <h6 class="alert-heading mb-1">
            <i class="fa-solid fa-info"></i>
            {{'Alert.info' | translate}}
        </h6>
        <span>
            <pre>
                {{item.message | jsonData}}
            </pre>
        </span>
        <button type="button" class="btn-close" data-bs-dismiss="alert" (click)="logService.deleteItemInfo(item.id)"
            aria-label="Close"></button>
    </div>
</div>